export default function DeleteControlTypeConfirmDialogController(
  $q,
  $rootScope,
  $scope,
  alerts,
  controlDataService,
  loaderService,
  ssDialogService
) {
  const vm = this;

  vm.handleCloseDialog = _handleCloseDialog;
  vm.handleConfirmDelete = _handleConfirmDelete;

  /** *********************************************
   * Event Handlers
   */

  function _handleCloseDialog($event) {
    _closeDialog($event);
  }

  function _handleConfirmDelete() {
    loaderService.showViewLoader = true;
    return controlDataService.deleteControlType(vm.controlType.customerControlTypeId).then((response) => {
      if (response.status === 200) {
        alerts.success(`The control type "${vm.controlType.name}" was successfully deleted.`);
        $rootScope.$broadcast('refreshAssetTypes');
        // loaderService.showViewLoader = false;
        if (vm.riskType) {
          $rootScope.$broadcast('pra_control-type-deleted', {
            controlType: vm.controlType,
            riskType: vm.riskType
          });
        } else {
          $rootScope.$broadcast('refreshControlTypes');
        }
        _closeDialog();
      } else {
        alerts.error('An error occurred while deleting the Control Type.');
        loaderService.showViewLoader = false;
      }
    });
  }

  /** *********************************************
   * Private Functions
   */

  function _closeDialog() {
    return ssDialogService.hide(ssDialogService.dialogs.controlAdmin.deleteControlTypeConfirmDialog);
  }
}

DeleteControlTypeConfirmDialogController.$inject = [
  '$q',
  '$rootScope',
  '$scope',
  'alerts',
  'controlDataService',
  'loaderService',
  'ssDialogService'
];
